import MuiList, { ListProps } from "@mui/material/List";

const List: React.FC<ListProps> = MuiList;

export default List;
export type { ListProps };
